/**
 * @file   api.js 后端异步接口管理
 * @author chengyuan<chengyuan06@baidu.com>
 * @date   2021-01-27
 */

export default {
    goodsDetail: {
        shopRec: '/web/skudetail/rec', // 店铺推荐
        coupon: '/web/skudetail/coupon' // 优惠券
    },
    pullUserActivity: {
        baiduTask: '/web/activity/baidutask' // 手百任务中心
    },
    lottery: {
        complete: '/web/draw/complete', // 完成任务
        taskReceive: '/web/draw/taskreceive' // 注册任务
    },
    follow: '/web/hudong/follow' // 关注
};
